"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_code_blocks_1 = require("react-code-blocks");
const CgpEvaluator_1 = require("./CgpEvaluator");
const CgpGenerator_1 = require("./CgpGenerator");
const CgpMutator_1 = __importDefault(require("./CgpMutator"));
exports.default = () => {
    const [generation, setGeneration] = React.useState(1);
    const [bestModel, setBestModel] = React.useState("");
    const [accuracy, setAccuracy] = React.useState(-1);
    const MIDDLE_NODES = 20;
    const POOL_SIZE = 50;
    const [pool, setPool] = React.useState((0, CgpGenerator_1.generateCgpPool)(POOL_SIZE, 4, MIDDLE_NODES, 3));
    const [fitnesses, setFitnesses] = React.useState(Array(POOL_SIZE).fill(0));
    function getBest(localPool, localFit) {
        const fitActual = localFit.filter((value) => Number.isFinite(value));
        const bestIdx = localFit.indexOf(Math.max(...fitActual));
        return localPool[bestIdx];
    }
    function evaluateFitnesses(localPool) {
        return __awaiter(this, void 0, void 0, function* () {
            const fitnesses = yield Promise.all(localPool.map((prog) => {
                return (0, CgpEvaluator_1.evaluateProgramFitness)(prog, 4, MIDDLE_NODES, 3);
            }));
            return fitnesses;
            //setFitnesses(fitnesses);
        });
    }
    function mutatePool(localPool) {
        const newPool = localPool.map((prog) => {
            return (0, CgpMutator_1.default)(prog, 4, MIDDLE_NODES, 3);
        });
        return newPool;
        //setPool(newPool);
    }
    function runTournamentSelection(localPool, localFit) {
        const newPool = new Array();
        for (let i = 0; i < POOL_SIZE; i++) {
            const idxA = Math.floor(Math.random() * POOL_SIZE);
            const idxB = Math.floor(Math.random() * POOL_SIZE);
            if (localFit[idxA] > localFit[idxB]) {
                newPool.push(localPool[idxA]);
            }
            else {
                newPool.push(localPool[idxB]);
            }
        }
        return newPool;
    }
    return (React.createElement("div", null,
        React.createElement("p", null, "If you clicked the \"run generation\" button in the last post enough times, you should have seen that in most cases, a solution for 95% accuracy is eventually found. But there's a problem in that you have to click that button a while."),
        React.createElement("p", null, "While I could very easily do a for-loop and run 10/20/100 generations at a time, there is the gotcha that this blocks the JS event loop. So, we'll have to be a bit smarter."),
        React.createElement("h2", null, "Bulk running"),
        React.createElement("p", null, "The first thing we need to address is how we're evaluating programs/nodes. Right now, the process is:"),
        React.createElement(react_code_blocks_1.CodeBlock, { text: `const fitnesses: number[] = new Array();
IrisData.forEach((data) => {
// Get our inputs:
const inputs: number[] = data.inputs;
const outputs = evaluate(inputs);
fitnesses.push(measureFitness(outputs, data.expected_output))
})` }),
        React.createElement("p", null, "Which essentially is loop over every program (not shown), loop over every training data point, evaluate and measure the fitness. Which is just absolutely horrendeous. As we're looking at the entire training set, we should try and take advantage of bulk operations where possible."),
        React.createElement(react_code_blocks_1.CodeBlock, { text: `const fitnesses: number[] = new Array();
const inputs = IrisData.map((d) => d.inputs);
const outputs = inputs.map((i) => evaluate(i));
const expected_outputs = IrisData.map((d) => d.expected_output);
const fitnesses = outputs.map((o, idx) => measureFitness(o, expected_outputs[idx]));` }),
        React.createElement("p", null, "Right now, this is functionally the same, but allows switching a single operation (ex: evaluate(i)) into a bulk operation (ie: evaluate_bulk(inputs)), taking advantage of matrix libraries such as math.js."),
        React.createElement("h2", null, "Running in a Web Worker"),
        React.createElement("p", null, "Now for the bulk of the transition. We have to avoid blocking the event loop, which means 1 of 2 options:"),
        React.createElement("ul", null,
            React.createElement("li", null, "Keeping computation pieces \"small\" so that the event loop can interleave clicks and updates between pieces (ie: using a bunch of promises/callbacks)."),
            React.createElement("li", null,
                "Using a javascript",
                " ",
                React.createElement("a", { href: "https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers" }, "web worker"))),
        React.createElement("p", null, "The web worker has a small issue, in that the constructor takes a URL of the script the worker will execute. Given that this entire site is designed using typescript/react, while this is possible (static files), this is not ideal. So we will be opting for the first solution, which is surprisingly simple. We'll wrap a generation in a function, and call it via setTimeout with a time of 0. This allows the event loop to process as normal in between generations:"),
        React.createElement(react_code_blocks_1.CodeBlock, { text: `var i=0;
(async function run(){
curPool = runTournamentSelection(curPool, curFitnesses);
curPool = mutatePool(curPool);
curFitnesses = await evaluateFitnesses(curPool);
setPool(curPool);
setFitnesses(curFitnesses);
i++;
if(i < 100){
    setTimeout(run, 0);
}
})();` }),
        React.createElement("p", null, "And because the event loop includes the react state updates, it'll keep the text up to date as well each generation."),
        React.createElement("p", null, "Anyways enough talk, here's the button in action:"),
        React.createElement(react_code_blocks_1.CodeBlock, { text: `Generation: ${generation}
Best model: ${bestModel}
Accuracy: ${accuracy}` }),
        React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                const localPool = (0, CgpGenerator_1.generateCgpPool)(POOL_SIZE, 4, MIDDLE_NODES, 3);
                const localFit = yield evaluateFitnesses(localPool);
                // Find the best:
                const best = getBest(localPool, localFit);
                setAccuracy((0, CgpEvaluator_1.evaluateProgramAccuracy)(best, 4, MIDDLE_NODES, 3));
                setPool(localPool);
                setFitnesses(localFit);
                setGeneration(1);
                setBestModel(best);
            }) }, "Reset Pool"),
        React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                // Nice part is we already have the fitnesses:
                const newPool1 = runTournamentSelection(pool, fitnesses);
                const newPool2 = mutatePool(newPool1);
                const newFitnesses2 = yield evaluateFitnesses(newPool2);
                // Find the best:
                const best = getBest(newPool2, newFitnesses2);
                setAccuracy((0, CgpEvaluator_1.evaluateProgramAccuracy)(best, 4, MIDDLE_NODES, 3));
                setPool(newPool2);
                setFitnesses(newFitnesses2);
                setGeneration(generation + 1);
                setBestModel(best);
            }) }, "Run generation"),
        React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                let curPool = pool;
                let curFitnesses = fitnesses;
                let curGeneration = generation;
                let i = 0;
                (function run() {
                    return __awaiter(this, void 0, void 0, function* () {
                        // Nice part is we already have the fitnesses:
                        const newPool1 = runTournamentSelection(curPool, curFitnesses);
                        curPool = mutatePool(newPool1);
                        curFitnesses = yield evaluateFitnesses(curPool);
                        // Find the best:
                        const best = getBest(curPool, curFitnesses);
                        setAccuracy((0, CgpEvaluator_1.evaluateProgramAccuracy)(best, 4, MIDDLE_NODES, 3));
                        setPool(curPool);
                        setFitnesses(curFitnesses);
                        curGeneration = curGeneration + 1;
                        setGeneration(curGeneration);
                        setBestModel(best);
                        i++;
                        if (i < 100) {
                            setTimeout(run, 0);
                        }
                    });
                })();
            }) }, "Run 100 generations")));
};
